import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import TagIcon from "@redotech/redo-icons/tag-01.svg";
import TagFilledIcon from "@redotech/redo-icons/tag-01_filled.svg";
import { MerchantRoutesContext } from "@redotech/redo-merchant-app-common/merchant-routes";
import { RedoConversionRpcClientContext } from "@redotech/redo-merchant-app-common/redo-conversion-rpc-client-provider";
import { ScheduleDemoButtonLocation } from "@redotech/redo-merchant-conversion-rpc/schema/analytics/send-schedule-demo-clicked-notification";
import { RedoSecondaryNavItem } from "@redotech/redo-web/arbiter-components/navigation/secondary/redo-secondary-nav-item";
import { memo } from "react";
import { useConversionLockedAction } from "../../../../conversion/locked/use-conversion-locked-action";

export const PricingTestItems = memo(function PricingTestItems() {
  const routes = useRequiredContext(MerchantRoutesContext);
  const conversionRpcClient = useRequiredContext(
    RedoConversionRpcClientContext,
  );
  const { locked, onLockedClick } = useConversionLockedAction(
    ScheduleDemoButtonLocation.NAV_PRICING_TESTS,
  );

  const hasPricingTestsLoad = useLoad(
    async (signal) => {
      const result = await conversionRpcClient.merchantHasPricingTests(
        {},
        { signal },
      );
      return result.hasPricingTests;
    },
    [conversionRpcClient],
  );

  if (hasPricingTestsLoad.pending || !hasPricingTestsLoad.value) {
    return null;
  }

  return (
    <RedoSecondaryNavItem
      action={
        locked
          ? { type: "button", onClick: onLockedClick }
          : {
              type: "link",
              href: routes.getConversionSubRoute("pricing-tests"),
            }
      }
      dimmed={locked}
      FilledIcon={TagFilledIcon}
      friendlyName="Pricing tests"
      id="pricing-tests"
      isPrivate={locked}
      UnfilledIcon={TagIcon}
    />
  );
});
